import type { TAllergen } from "@./suf-store";

import { FlowNavigationContext } from "../../../shared/constants";
import { inABTestGroupFromSingleton } from "../featureFlags";
import { useSignupFlowStore } from "../hooks/useSignUpFlowStore";

export function getFlowNavigationContextFromStore(): FlowNavigationContext {
  const { cats } = useSignupFlowStore.getState();
  const catsAllergies = new Set(
    Object.values(cats).flatMap((cat) => cat.diet?.foodAllergies?.allergens ?? []),
  );

  return {
    inABTestGroup: inABTestGroupFromSingleton,
    hasAnyAllergy: (excludedAllergies: TAllergen[]) =>
      excludedAllergies.some((allergen) => catsAllergies.has(allergen)),
  };
}
